import { render, staticRenderFns } from "./GatheringStats.vue?vue&type=template&id=1fb8f1f6&"
import script from "./GatheringStats.vue?vue&type=script&lang=coffee&"
export * from "./GatheringStats.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GatheringStats.vue"
export default component.exports